@defer {
  <!-- Do not mind messy html, hailforge will provide new design so this becomes obsolete. -->
<!--suppress AngularUndefinedTag showBreadcrumbsMenu = false-->
<form [formGroup]="formGroup">
  <div>
    <div class="dropdown-container">
      <div class="w2c-columns is-vcentered left-dropdown">
        <div class="w2c-column">
          <div class="custom-select">
            <i class="fas fa-angle-down"></i>
            <label>
              <select formControlName="cloudStorage">
                @if (noCloudSelected()) {
                  <option disabled>{{'OPENSAVEDLG.SELECTDRIVE' | translate:currentCloudParam}}
                  </option>
                }
                @for (cloud of clouds; track cloud) {
                  <option [value]="cloud">
                    {{cloud}}
                  </option>
                }
              </select>
            </label>
          </div>
        </div>
      </div>

      @if (!noCloudSelected()) {
        <div class="w2c-columns is-vcentered right-dropdown">
          <div class="w2c-column">
            <div class="custom-select">
              <i class="fas fa-angle-down"></i>
              <label>
                <select formControlName="cloudFolders">
                  @for (cloudFolder of cloudFolders(); track cloudFolder) {
                    <option [value]="cloudFolder">
                      {{currentCloudForNgx + '.' + cloudFolder | translate}}
                    </option>
                  }
                </select>
              </label>
            </div>
          </div>
        </div>
      }
    </div>
  </div>


  @if (!noCloudSelected()) {
    <asg-breadcrumbs #breadcrumbs [currentCloud]="currentCloud"
      (rootBreadcrumbClicked)="openRootFolder(dialogStatus())" (breadcrumbClicked)="openFolder(MimeTypesEnum.Folder, true)">
    </asg-breadcrumbs>
  }

  <table class="asg-files-table">
    <thead class="table-head">
      <tr>
        <th class="icon-cell"></th>
        <th class="name-cell asg-files-table-header">
          <asg-cloud-storage-dialog-th
            [text]="'OPENSAVEDLG.NAME'"
            [param]="cloudSortingParams.name"
            [current]="cloudSortingData"
            (changeSortingClick)="handleSortingEvent($event)">
          </asg-cloud-storage-dialog-th>
        </th>
        <th [style.visibility]="folderListing !== CloudFoldersEnum.Recent ? 'visible' : 'hidden'" class="action-cell">
          {{'OPENSAVEDLG.MORE' | translate}}
        </th>
        <th class="size-cell asg-files-table-header">
          <asg-cloud-storage-dialog-th
            [text]="'OPENSAVEDLG.SIZE'"
            [param]="cloudSortingParams.size"
            [current]="cloudSortingData"
            (changeSortingClick)="handleSortingEvent($event)">
          </asg-cloud-storage-dialog-th>
        </th>
        <th class="modified-cell asg-files-table-header">
          <asg-cloud-storage-dialog-th
            [text]="'OPENSAVEDLG.MODIFIED'"
            [param]="cloudSortingParams.modifiedTime"
            [current]="cloudSortingData"
            (changeSortingClick)="handleSortingEvent($event)">
          </asg-cloud-storage-dialog-th>
        </th>
      </tr>
    </thead>
    <tbody id="tableContent">
      <!-- <tr *ngIf="!fileList && !noCloudSelected">{{'OPENSAVEDLG.RETRIEVING' | translate:currentCloudParam}}</tr> -->
      @if (isLoading()) {
        <tr class="spinner-container">
          <asg-pure-spinner></asg-pure-spinner>
        </tr>
      } @else {
        @for (file of fileList; track file; let i = $index) {
          <tr (click)="selectItem($event, file)"
            (dblclick)="openFolder(selectedItem?.mimeType)" class="{{file.id}} + ' pointer'">
            <td>
              @if (file.mimeType === MimeTypesEnum.SharedDrive) {
                <i class="material-icons">cloud</i>
              }
              @if (file.mimeType === MimeTypesEnum.Folder) {
                @if (!file.isShared) {
                  <i class="material-icons">folder</i>
                }
                @if (file.isShared) {
                  <i class="material-icons">folder_shared</i>
                }
              }
              @if (file.mimeType !== MimeTypesEnum.Folder) {
                @if (file.mimeType === MimeTypesEnum.ApplicationPdf) {
                  <i class="material-icons">picture_as_pdf</i>
                }
                @if (file.mimeType === MimeTypesEnum.ApplicationOctetStream) {
                  <i
                  class="material-icons">file_copy</i>
                }
                @if (
                  file.mimeType === MimeTypesEnum.TextRtf ||
                  file.mimeType === MimeTypesEnum.ApplicationRtf ||
                  file.mimeType === MimeTypesEnum.ApplicationMsWord ||
                  file.mimeType === MimeTypesEnum.ApplicationMSWordOpenXML ||
                  file.mimeType === MimeTypesEnum.ApplicationMsExcelOpenXML ||
                  file.mimeType === MimeTypesEnum.ApplicationMsPptOpenXML) {
                  <i class="material-icons">reorder</i>
                }
                @if (file.mimeType === MimeTypesEnum.GoogleDriveShortcut) {
                  <i class="fas fa-share-square"></i>
                }
                @if (file.mimeType === MimeTypesEnum.ApplicationEpub) {
                  <i class="material-icons size">file_copy</i>
                }
              }
              @if (file.mimeType === MimeTypesEnum.Mp3) {
                <i class="material-icons">audiotrack</i>
              }
            </td>
            <td class="name-cell">{{file.name}}</td>
            <td [style.visibility]="folderListing !== CloudFoldersEnum.Recent ? 'visible' : 'hidden'"
              asgTooltip="DIALOGS.MORE" class="action-cell" [matMenuTriggerFor]="menu"><i
            class="material-icons copyMenu">more_horiz</i></td>
            <mat-menu #menu="matMenu">
              @if (folderListing !== CloudFoldersEnum.Favorites) {
                <button mat-menu-item [disabled]="!(file.capabilities?.canRename ?? true)" (click)="doOperation(DialogOperationEnum.Rename)">
                  <span class="button-content"><i
                  class="material-icons">create</i>{{'ACTIONMENU.RENAME' | translate}}</span>
                </button>
              }
              @if (folderListing !== CloudFoldersEnum.Favorites) {
                <button mat-menu-item [disabled]="!(file.capabilities?.canCopy ?? true)" (click)="cutOrCopyFile(true)">
                  <span class="button-content"><i
                  class="material-icons">file_copy</i>{{'ACTIONMENU.COPY' | translate}}</span>
                </button>
              }
              @if (folderListing !== CloudFoldersEnum.Favorites) {
                <button mat-menu-item [disabled]="!(file.capabilities?.canMove ?? true)" (click)="cutOrCopyFile(false)">
                  <span class="button-content"><i
                  class="material-icons">swap_horiz</i>{{'ACTIONMENU.MOVE' | translate}}</span>
                </button>
              }
              @if (folderListing !== CloudFoldersEnum.Favorites && file.mimeType === MimeTypesEnum.Folder) {
                <button mat-menu-item (click)="toggleFavorite()">
                  @if ((isFavorite(file))) {
                    <span class="button-content"><i
                    class="material-icons">star_border</i>{{'ACTIONMENU.REMOVE_FAVORITE' | translate}}</span>
                  } @else {
                    <span class="button-content"><i
                    class="material-icons">star</i>{{'ACTIONMENU.ADD_FAVORITE' | translate}}</span>
                  }
                </button>
              }
              @if (folderListing !== CloudFoldersEnum.Favorites) {
                <button mat-menu-item [disabled]="!(file.capabilities?.canRemove ?? true)" (click)="deleteFile()">
                  <span class="button-content"><i
                  class="material-icons">delete</i>{{'ACTIONMENU.DELETE' | translate}}</span>
                </button>
              }
              @if (folderListing === CloudFoldersEnum.Favorites) {
                <button mat-menu-item (click)="toggleFavorite()">
                  @if ((isFavorite(file))) {
                    <span class="button-content"><i
                    class="material-icons">star_border</i>{{'ACTIONMENU.REMOVE_FAVORITE' | translate}}</span>
                  } @else {
                    <span class="button-content"><i
                    class="material-icons">star</i>{{'ACTIONMENU.ADD_FAVORITE' | translate}}</span>
                  }
                </button>
              }
            </mat-menu>
            <td class="size-cell">{{file.size ? (+file.size / 1000  | roundedNumber) + ' KB' : ''}}</td>
            <td class="modified-cell">{{ parseDate(file.modifiedTime) | date: 'dd/MM/yyyy HH:mm' }}</td>
          </tr>
        }
      }

      <ng-template #spinner>
        <tr class="spinner-container">
          <asg-pure-spinner></asg-pure-spinner>
        </tr>
      </ng-template>


    </tbody>
  </table>

  <div class="stay-down">
    <div class="w2c-columns is-vcentered">
      <div class="w2c-column w2c-column--title">
        <!-- value="{{getFilenameAndExtension().filename}}" -->
        <!-- <input *ngIf="dialogStatus !== SaveStatusEnum.AudioSave && dialogStatus !== SaveStatusEnum.Open" type="text"
        size="50" formControlName="inputControl" value="filename.name"
        class="filenameField" /> -->
        <!-- value="{{getFilenameAndExtension().filename}}"  -->
        <input [hidden]="!dialogStatus" [readonly]="readOnlyInput()"
          type="text" size="50" formControlName="inputControl" value="{{filename | fileName}}"
          class="filenameField" />
        </div>
        <div>{{filename | fileExtension}}</div>
        <div class="w2c-column">
          <div class="custom-select">
            <i class="fas fa-angle-down"></i>
              @if (dialogStatus() === SaveStatusEnum.Ocr) {
              <label>
                <select formControlName="supportedControl">
                  <option [ngValue]="false">{{'OPENSAVEDLG.SUPPORTED' | translate}}</option>
                </select>
              </label>
              }
              
              @if (dialogStatus() !== SaveStatusEnum.Ocr) {
              <label>
                <select formControlName="supportedControl">
                  <option [ngValue]="false">{{'OPENSAVEDLG.SUPPORTED' | translate}}</option>
                  <option [ngValue]="true">{{'OPENSAVEDLG.ALLFILES' | translate}}</option>
                </select>
              </label>
              }
          </div>
        </div>
      </div>
      <p [style.visibility]="folderListing !== CloudFoldersEnum.Recent ? 'visible' : 'hidden'"
        class="fa-pull-left hyperlink" (click)="doOperation(DialogOperationEnum.NewFolder)"
        asgTooltip="DIALOGS.NEWFOLDER"><i class="material-icons max-size">create_new_folder</i></p>
        <div class="bottom-right">

          <!-- open/save -->
          @if (dialogStatus() === SaveStatusEnum.Open || dialogStatus() === SaveStatusEnum.Ocr) {
            <input type="submit" class="cb-btn top" [ngClass]="{'disabled' : selectedItem === null}"
              value="{{'OPENSAVEDLG.OPEN' | translate}}" (click)="openFolder(selectedItem?.mimeType)" />
          }
          @if (dialogStatus() === SaveStatusEnum.Save) {
            <input type="submit" class="cb-btn"
              value="{{'OPENSAVEDLG.SAVE' | translate}}" (click)="saveAsFile();" />
          }
          @if (dialogStatus() === SaveStatusEnum.AudioSave) {
            <input type="submit" class="cb-btn"
              value="{{'OPENSAVEDLG.SAVE' | translate}}" (click)="saveAudiofile();ok();" />
          }
          @if (dialogStatus() === SaveStatusEnum.ExamCreationFilePicker) {
            <input type="submit" class="cb-btn" [ngClass]="{'disabled' : selectedItem === null || selectedItem.mimeType === MimeTypesEnum.Folder}"
              value="{{'OPENSAVEDLG.ADD' | translate}}" (click)="examModeAdd()">
          }
          @if (dialogStatus() === SaveStatusEnum.ExamModeFilePicker) {
            <input type="submit" class="cb-btn" [ngClass]="{'disabled' : selectedItem === null || selectedItem.mimeType === MimeTypesEnum.Folder}"
              value="{{'OPENSAVEDLG.ADD' | translate}}" (click)="examModeAdd()">
          }
          @if (dialogStatus() === SaveStatusEnum.CompletedExamModeFileSave) {
            <input type="submit" class="cb-btn"
              value="{{'OPENSAVEDLG.SAVE' | translate}}" (click)="completedExamModeSave()">
          }

          <!-- cancel -->
          @if (cancelDialog()) {
            <input type="submit"
              class="cb-btn fa-pull-right" value="{{'OPENSAVEDLG.CANCEL' | translate}}" (click)="okPress();" />
          }
          @if (dialogStatus() === SaveStatusEnum.AudioSave) {
            <input type="submit" class="cb-btn fa-pull-right"
              value="{{'OPENSAVEDLG.CANCEL' | translate}}" (click)="ok();" />
          }
          @if (dialogStatus() === SaveStatusEnum.ExamCreationFilePicker) {
            <input type="submit" class="cb-btn fa-pull-right"
              value="{{'OPENSAVEDLG.CANCEL' | translate}}" (click)="examModeCancel()">
          }
          @if (dialogStatus() === SaveStatusEnum.ExamModeFilePicker) {
            <input type="submit" class="cb-btn fa-pull-right"
              value="{{'OPENSAVEDLG.CANCEL' | translate}}" (click)="examModeCancel()">
          }
          @if (dialogStatus() === SaveStatusEnum.CompletedExamModeFileSave) {
            <input type="submit" class="cb-btn fa-pull-right"
              value="{{'OPENSAVEDLG.CANCEL' | translate}}" (click)="completedExamModeCancel()">
          }
        </div>
      </div>
    </form>
}